import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();

  // Ensure Dutch is selected by default on component mount
  useEffect(() => {
    if (!i18n.language || i18n.language === "en") {
      i18n.changeLanguage("nl");
    }
  }, [i18n]);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="relative inline-flex bg-gray-100 rounded-full p-1">
      <button
        onClick={() => changeLanguage("en")}
        className={`relative px-4 py-2 text-sm font-medium transition-all duration-300 rounded-full ${
          i18n.language === "en"
            ? "bg-primaryColor text-white shadow-sm"
            : "text-gray-700 hover:text-gray-900"
        }`}
      >
        {t("navbar.english")}
      </button>
      <button
        onClick={() => changeLanguage("nl")}
        className={`relative px-4 py-2 text-sm font-medium transition-all duration-300 rounded-full ${
          i18n.language === "nl"
            ? "bg-primaryColor text-white shadow-sm"
            : "text-gray-700 hover:text-gray-900"
        }`}
      >
        {t("navbar.dutch")}
      </button>
    </div>
  );
};

export default LanguageSwitcher;
